import { isAlphaNumericKey, isNavigationKey, keyCodes } from '@silevis/reactgrid';
import React from 'react';
import { Pencil } from 'react-bootstrap-icons';
import { handleKeyDownDefault } from '../../helpers/global';

class EditableCellTemplate {
  getCompatibleCell(uncertainCell) {
    return {
      ...uncertainCell,
      text: uncertainCell.text || '',
      onClick: uncertainCell.onClick || (() => {}),
      nonEditable: uncertainCell.nonEditable || false
    };
  }

  handleKeyDown(cell, keyCode, ctrl, shift, alt) {
    return handleKeyDownDefault(cell, keyCode, ctrl, shift, alt);
  }

  update(cell, cellToMerge) {
    return { ...cell, ...cellToMerge };
  }

  render(cell) {
    return (
      <div
        className="d-flex justify-content-center align-items-center w-100 px-4 gap-2"
        style={{ height: '100%' }}
        onKeyDown={e => {
          if (isAlphaNumericKey(e.keyCode) || isNavigationKey(e.keyCode)) {
            e.stopPropagation();
          }
        }}
        onPointerDown={e => e.stopPropagation()}
      >
        <span>{cell.text}</span>
        {cell.onClick && (
          <Pencil
            className="hover-light cursor-pointer"
            onClick={e => {
              e.stopPropagation();
              cell.onClick();
            }}
            size={14}
          />
        )}
      </div>
    );
  }
}

export const editableCellTemplate = new EditableCellTemplate();
